export enum TrackingEvent {
    PRESENTATION_FORM_SUBMIT = 'Presentation form: submit',
    PRESENTATION_FORM_CHANGE_EMAIL = 'Presentation form: change email',
}
